<template>
    <tr>
        <td>
            <div>{{ articleName }}</div>
            <div v-if="articleHasPerson" style="font-size: smaller">
                <div class="ml-3" v-for="invoiceArticle in invoiceArticlesGroup">
                    @
                    <PersonName :person="registrationData.persons[invoiceArticle.belongsToPersonKey]"
                                :index="registrationData.participatingPersons.findIndex((personKey) => personKey === invoiceArticle.belongsToPersonKey)">

                    </PersonName>
                </div>
            </div>
        </td>
        <td class="text-right">
            <div>{{ articleAmount }}</div>
            <div v-if="articleHasPerson" style="font-size: smaller">
                <div class="ml-3" v-for="invoiceArticle in invoiceArticlesGroup">
                    {{ invoiceArticle.amount }}
                </div>
            </div>
        </td>
        <td class="text-right text-nowrap">
            <div>{{ convertToHumanNumber(totalArticlePrice, isDecimalPrice) }} {{ currencySymbol }}</div>
            <div v-if="articleHasPerson && false" style="font-size: smaller">
                <div class="ml-3" v-for="invoiceArticle in invoiceArticlesGroup">
                    <span>{{ convertToHumanNumber(articleTotal(invoiceArticle), isDecimalPrice) }}
                        {{ currencySymbol }}
                    </span>
                </div>
            </div>
        </td>
    </tr>
</template>
<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import PersonName from "@/components/pages/registration/persons/PersonName";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: 'InvoiceArticlesGroup',
    components: {PersonName},
    mixins: [registrationPriceMixin, mainRegistrationMixin],
    props: {
        invoiceArticlesGroup: {
            type: Array,
            required: true
        },
        isDecimalPrice: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        articleName() {
            return this.invoiceArticlesGroup[0].name
        },
        articleAmount() {
            let counter = 0
            for (let invoiceArticle of this.invoiceArticlesGroup) {
                // the API delivers amount as a string, so coerce before summing
                counter += Number(invoiceArticle.amount ?? 1)
            }
            return counter
        },
        totalArticlePrice() {
            let total = 0
            for (let invoiceArticle of this.invoiceArticlesGroup) {
                total += this.articleTotal(invoiceArticle)
            }
            return total
        },
        articleHasPerson() {
            return !!this.invoiceArticlesGroup[0].belongsToPersonKey
        }
    },
    methods: {
        articleTotal(article) {
            if (article?.isGross ?? false)
                return this.$roundCommercially((article.amount ?? 1) * (article.unitPrice ?? 0))
            else
                return this.$roundCommercially((article.amount ?? 1) * (article.unitPrice ?? 0) * (article.tax / 100 + 1))
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
